import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import { BiBookmark } from "react-icons/bi";
import { PiSealCheckFill } from "react-icons/pi";

const CaptionsSubtitleComp = () => {
  const gridItems = [
    {
      id: 1,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 2,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 3,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 4,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 5,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 6,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 7,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 8,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 9,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 10,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 11,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 12,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 13,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },
    {
      id: 14,
      logo: "https://aitoolsbazaar-image.s3.ap-south-1.amazonaws.com/tools/1734699604375-Snopes%20Factbot%20logo.webp",
      title: "Snopes Factbot",
      description: "Video Captions API with premium templates",
      category: "🤖 Captions or Subtitle",
      price: "Free",
      link: "https://www.firecrawl.dev/smart-crawl?ref=aitoolsbazaar&utm_source=aitoolsbaar&utm_medium=referral",
      tags: ["writing generators", "storyteller", "copywriting"], // Tags array
    },

    // Add more items similarly...
  ];

  const [visibleCount, setVisibleCount] = useState(10); // Initial number of items to show
  const itemsToLoad = 6; // Number of items to load on each click

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + itemsToLoad);
  };

  return (
    <section className="bg-background-back1 overflow-hidden py-24">
      <div className="container max-w-[80rem] mx-auto px-4 pt-5">
        {/* Header Section */}
        <div className="flex justify-between items-center mt-5 mb-3 w-full">
          <Link to="#">
            <h4 className="font-sans tracking-wide text-lg lg:text-2xl font-bold text-white">
              Captions or Subtitle
            </h4>
          </Link>
        </div>
        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {gridItems.slice(0, visibleCount).map((item) => (
            <div
              key={item.id}
              className="blurBox bg-gray-900 rounded-xl overflow-hidden shadow-lg p-4 transition-transform duration-200"
            >
              <div className="relative flex items-center gap-2">
                <div className="relative">
                  <img
                    src={item.logo}
                    alt={`${item.title} logo`}
                    className="h-12 w-12 rounded-full"
                  />
                  <span className="absolute -top-[0px] -right-[0px] h-4 w-4 rounded-full flex items-center justify-center">
                    <PiSealCheckFill
                      className="text-primary h-4 w-4 bg-white rounded-full"
                    />
                  </span>
                </div>
                <div className="flex flex-col truncate">
                  <h5 className="text-lg font-bold text-white truncate">
                    {item.title}
                  </h5>
                  <Link to="#">
                    <p className="text-sm text-gray-400 truncate text-primary">
                      {item.category}
                    </p>
                  </Link>
                </div>
              </div>
              <div>
                <p className="text-sm text-gray-400 truncate">{item.description}</p>
                {/* Dynamic Tags */}
                <div className="flex flex-wrap mt-2 gap-2 leading-none">
                  {item.tags.map((tag, index) => (
                    <Link
                      to={`/tags/${encodeURIComponent(tag)}`}
                      key={index}
                      className="text-primary text-[13px] hover:underline"
                    >
                      #{tag}
                    </Link>
                  ))}
                </div>
              </div>
              <img
                src={item.logo}
                alt={item.title}
                className="w-full mt-3 rounded-lg object-cover lg:h-40"
              />
              <div className="flex justify-between items-center">
                <div className="mt-3 flex">
                  <span className="text-sm text-gray-400">{item.price}</span>
                </div>
                <div className="flex flex-col mt-2">
                  <div className="flex">
                    <div className="flex">
                      <Link to="">
                        <div>
                          <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                        </div>
                      </Link>
                      <Link to="" className="ml-2">
                        <FiExternalLink className="w-4 h-4 sm:w-4.5 sm:h-4.5 lg:w-5 lg:h-5 text-primary hover:text-white" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Load More Button */}
        {visibleCount < gridItems.length && (
          <div className="flex justify-center mt-6">
            <button
              onClick={handleLoadMore}
              className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default CaptionsSubtitleComp;
